import React, { useState, useEffect, useRef, divRef, lazy, Suspense } from "react";
import { alert_error, alert_success } from "../../../../AppContext";
import { Cookies } from "../../../../index.js";
import Iframe from 'react-iframe';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import AdSense from 'react-adsense';
import { ClipLoader, PulseLoader } from 'react-spinners';
import Post_content from '../../../../community/content/Blog_posts.jsx';
import Mode_videos_instruct_2 from "./mode_videos_instruct_2.jsx"; // đường dẫn tới file con
import Language_i18 from "../../../../js/useNationalLanguage.jsx";
import Mode_videos_instruct_3 from "./mode_videos_instruct_3.jsx";

const LazyReCAPTCHA = lazy(() => import("../../../../app_structure/LazyReCAPTCHA"));

const Jopsearch = ({ datajoptiktok }) => {
    const iframeId = 'iframeContainer'; // Đặt id cho phần tử div
    const [iframeHeight, setIframeHeight] = useState(null); //None Kích thước mặc định
    const location = useLocation();
    const { lang } = Language_i18();
    const recaptchaRef = React.createRef();
    const [currentStep, setCurrentStep] = useState(1);
    const [stepDescription, set_stepDescription] = useState("");
    const [nutxuly, setnutxuly] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const [iframeKey, setIframeKey] = useState(0);
    const [chuadangnhap, setchuadangnhap] = useState(true);
    const [gtoken, setgtoken] = useState('');
    const [chedo, setchedo] = useState(false);
    const [loadcheoweb, setloadcheoweb] = useState(false);
    const [data_ok, setdata_ok] = useState(null);
    const [linkweb, setLinkweb] = useState(""); // Khai báo biến linkweb ở đây và khởi tạo giá trị ban đầu là chuỗi rỗng
    const [api_key, setapi_key] = useState('');
    const [buttonTextjop, setbuttonTextjop] = useState("Xác Thực Captcha để nhận Coins nhé");
    const [count, setCount] = useState(10);

    useEffect(() => {
        if (count > 0) {
            const countdownInterval = setInterval(() => {
                setCount(count - 1);
            }, 1000);

            return () => clearInterval(countdownInterval);
        }
    }, [count]);
    useEffect(() => {
        // Tìm phần tử div với id
        const divElement = document.getElementById(iframeId);

        // Nếu phần tử không tồn tại, hãy tạo nó
        if (!divElement) {
            const newDiv = document.createElement('div');
            newDiv.id = iframeId;
            document.body.appendChild(newDiv);
        }

        // Cập nhật kích thước iframe
        const divTop = document.getElementById(iframeId).getBoundingClientRect().top;
        const windowHeight = window.innerHeight * 0.83;
        const newHeight = `${windowHeight - divTop}px`;
        setIframeHeight(newHeight);
    }, []);
    useEffect(() => {
        setTimeout(() => {
            const myCookieValue = Cookies.get('apikey');
            console.log(myCookieValue);
            setapi_key(myCookieValue);
        }, 100);
    }, []);
    useEffect(() => {
        const myCookieValue = Cookies.get('apikey');
        if (myCookieValue) {
            if (api_key != '') {
                setchuadangnhap(false);
            }
        }
        setTimeout(() => {
            if (myCookieValue) {
                if (api_key != '') {
                    setchuadangnhap(false);
                    laydulieujop();
                }
            }
            else {
                setIsDisabled(true);
                setchuadangnhap(true);
            }
        }, 400);

    }, [api_key]);
    const handleContinue = () => {
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
        } else {
            // Nếu ở bước cuối, quay lại bước đầu
            setCurrentStep(1);
        }
    };
    const laydulieujop = async () => {
        setIsDisabled(false);
        setdata_ok(null);
        if (location.pathname.includes('/proweb')) {
            const jasdjnlaksdl = 'search';
            setchedo(jasdjnlaksdl);
        }
        else if (location.pathname.includes('/cheoweb')) {
            const jasdjnlaksdl = 'cheoweb';
            setchedo(jasdjnlaksdl);
        }
    };

    const resetRecaptcha = () => {
        window.grecaptcha.reset();
        setgtoken(null);
    };

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };

    useEffect(() => {
        if (!datajoptiktok) return;
        const description = Mode_videos_instruct_2({ datajoptiktok, lang });
        if (description) {
            set_stepDescription(description);
        }
    }, [datajoptiktok, lang]);

    const stepColors = {
        1: "bg-red-400",
        2: "bg-purple-400",
        3: "bg-blue-400",
    };

    return (
        <div>
            <div className="w-full h-full">
                <div className="flex flex-col justify-center items-center">
                    <div className="mt-1 p-2 rounded-lg w-full shadow-xl bg-gradient-to-r from-pink-400 to-purple-400">
                        <div className="px-2" >
                            {location.pathname.includes('/proweb') && !chuadangnhap &&
                                (<>
                                    <h1 className="text-2xl font-bold text-white mb-3">HƯỚNG DẪN xem LINK</h1>
                                    <p className="text-base text-white mb-3">
                                        Lưu ý: Vui lòng không sử dụng Proxy (VPN), 1.1.1.1 khi vượt link.
                                    </p></>)
                            }
                            <div id={iframeId} >    </div>
                            {!chuadangnhap && (<>     {

                                data_ok && !chuadangnhap ? (
                                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                                        <ClipLoader color="#fff" size={150} />
                                    </div>
                                ) :

                                    (location.pathname.includes('/proweb') || location.pathname.includes('/cheoweb')) && (
                                        <>
                                            <h2>Hết nhiệm vụ, vui lòng xem xét làm jop khác hoặc mua sắm để hỗ trợ cộng đồng. 🛍️</h2>
                                        </>
                                    )}
                            </>)}
                            {chuadangnhap ? (<>
                                <div className="z-index-1 position-relative">
                                    <a className="link-light mb-4 font-sans-serif fs-4 d-inline-block fw-bolder" href="/">hust.media</a>
                                    <p className="opacity-75 text-black">Là một hệ thống trao đổi tương tác một cách tự nhiên và an toàn. Hệ thống hoạt động theo nguyên tắc tự nguyện trao đổi giữa các thành viên, cùng giúp nhau tăng tương tác, tăng hiệu quả bán hàng, truyền thông.<br />#traodoisub , #tangsub, #tuongtaccheo, #tuongtacfb, #tangtheodoimienphi, #tanglikemienphi, #tanglike, #tangtheodoi, #tangcmt, #tangcamxuc, #tangshare, #cayxu, #toolcayxu, #tangview, #tangtiktok, #traodoitiktok, #tiktok </p>
                                </div>
                            </>) : (
                                <>{datajoptiktok && !location.pathname.includes('/proweb')
                                    && (
                                        <>
                                            {datajoptiktok.magiaodich && (<>    <div className="flex text-base flex-col gap-4">

                                                {Object.keys(stepDescription).map((step) => (
                                                    <div
                                                        key={step}
                                                        className={`rounded-lg mx-3 py-2 ${stepColors[step]} ${currentStep === parseInt(step) ? "block" : "hidden"
                                                            }`}
                                                    >
                                                        <h2 className="text-xl font-bold text-white mb-2">Bước {step}
                                                            {currentStep === 1 && (
                                                                <> id: {datajoptiktok.id}</>
                                                            )}</h2>
                                                        <p className="text-lg text-white mb-4">{stepDescription[step]}</p>
                                                        {currentStep === parseInt(step) ? (
                                                            <div className="flex gap-2">
                                                                {currentStep === 1 && (
                                                                    <button
                                                                        onClick={() => saochep(datajoptiktok.url_copy)}
                                                                        type="button"
                                                                        className="bg-blue-500 text-white font-bold py-2 px-4 rounded"
                                                                    >
                                                                        Sao chép
                                                                    </button>
                                                                )}

                                                                <button
                                                                    type="button"
                                                                    className="bg-white text-purple-400 font-bold py-2 px-4 rounded"
                                                                    onClick={handleContinue}
                                                                >
                                                                    {currentStep < 3 ? "Tiếp tục" : "Quay lại Bước 1"}
                                                                </button>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                ))}
                                            </div> </>)}
                                        </>
                                    )
                                }</>)}
                        </div>
                        <Mode_videos_instruct_3 datajoptiktok={datajoptiktok} />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Jopsearch;
